import moment from 'moment';
import { useMemo, useState } from 'react';
import { periodDatesByName, PeriodName } from 'utils/periodDates';

const defaultPeriodDates: [Date, Date] = [
  moment().startOf('month').toDate(),
  moment().endOf('month').toDate(),
];

export const usePeriodDates = () => {
  const [periodName, setPeriodName] = useState<PeriodName>('current month');
  const [customPeriodDates, setCustomPeriodDates] =
    useState<[Date, Date]>(defaultPeriodDates);

  const startDate = useMemo(
    () =>
      periodName === 'custom'
        ? customPeriodDates[0]
        : (periodDatesByName[periodName] ?? defaultPeriodDates)[0],
    [periodName, customPeriodDates]
  );

  const endDate = useMemo(
    () =>
      periodName === 'custom'
        ? customPeriodDates[1]
        : (periodDatesByName[periodName] ?? defaultPeriodDates)[1],
    [customPeriodDates, periodName]
  );

  return {
    periodName,
    customPeriodDates,
    startDate,
    endDate,
    setPeriodName,
    setCustomPeriodDates,
  };
};
